var thousandsRegEx = new RegExp(/\B(?=(\d{3})+(?!\d))/g);

const currency = function (value) {
	return (
		parseFloat(value)
			.toFixed(2)
			.replace(thousandsRegEx, ' ')
			.replace('.', ',') + ' zł'
	);
};

const currencyAlt = function (value) {
	return parseFloat(value)
		.toFixed(2)
		.replace(thousandsRegEx, ' ')
		.replace('.', ',');
};

const date = function (value) {
	var date = new Date(value),
		day = date.getDate(),
		month = date.getMonth() + 1,
		year = date.getFullYear();

	if (day < 10) day = '0' + day;
	if (month < 10) month = '0' + month;

	return day + '.' + month + '.' + year;
};

const day = function (value) {
	var date = new Date(value),
		day = date.getDate();

	return day;
};

const monthAndYear = function (value) {
	var date = new Date(value),
		year = date.getFullYear(),
		monthIndex = date.getMonth(),
		monthName = '';

	switch (monthIndex) {
		case 0:
			monthName = 'Styczeń';
			break;
		case 1:
			monthName = 'Luty';
			break;
		case 2:
			monthName = 'Marzec';
			break;
		case 3:
			monthName = 'Kwiecień';
			break;
		case 4:
			monthName = 'Maj';
			break;
		case 5:
			monthName = 'Czerwiec';
			break;
		case 6:
			monthName = 'Lipiec';
			break;
		case 7:
			monthName = 'Sierpień';
			break;
		case 8:
			monthName = 'Wrzesień';
			break;
		case 9:
			monthName = 'Październik';
			break;
		case 10:
			monthName = 'Listopad';
			break;
		case 11:
			monthName = 'Grudzień';
			break;
		default:
			monthName = '';
			break;
	}

	return monthName + ' ' + year;
};

const time = function (value) {
	var date = new Date(value),
		hour = date.getHours(),
		minutes = date.getMinutes();

	if (hour < 10) hour = '0' + hour;
	if (minutes < 10) minutes = '0' + minutes;

	return hour + ':' + minutes;
};

module.exports = {
	currency,
	currencyAlt,
	date,
	day,
	monthAndYear,
	time,
};
